import React from "react";
import { fetchPhotographerStats } from "../../../util/settings_api_util";

const styles = {
  filters: { display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "flex-end", marginBottom: "16px" },
  buttons: { display: "flex", gap: "10px", alignItems: "center", marginBottom: "24px" },
  btn: { margin: 0, height: "46px", padding: "0 28px", display: "inline-flex", alignItems: "center", justifyContent: "center" },
  table: { width: "100%", borderCollapse: "collapse", marginTop: "8px" },
  th: { textAlign: "left", padding: "10px 12px", borderBottom: "2px solid #e2e2e2", fontWeight: 600 },
  thRight: { textAlign: "right", padding: "10px 12px", borderBottom: "2px solid #e2e2e2", fontWeight: 600 },
  td: { textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #efefef" },
  tdRight: { textAlign: "right", padding: "10px 12px", borderBottom: "1px solid #efefef" },
  foot: { fontWeight: 700, borderTop: "2px solid #e2e2e2" },
  message: { padding: "16px 4px", color: "#777" }
};

export default class PhotographerStats extends React.Component {
  constructor(props) {
    super(props);
    const ytd = PhotographerStats.ytdRange();
    this.state = {
      startDate: ytd.startDate,
      endDate: ytd.endDate,
      search: "",
      rows: [],
      totals: { jobs: 0, revenue: 0, paid: 0, photographers: 0 },
      loading: false,
      loaded: false
    };
    this.handleInput = this.handleInput.bind(this);
    this.loadStats = this.loadStats.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
  }

  static ytdRange() {
    const today = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    return {
      startDate: `${today.getFullYear()}-01-01`,
      endDate: `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`
    };
  }

  componentDidMount() {
    this.loadStats();
  }

  handleInput(field) {
    return (e) => this.setState({ [field]: e.target.value });
  }

  loadStats() {
    const { startDate, endDate, search } = this.state;
    this.setState({ loading: true });
    fetchPhotographerStats(startDate, endDate, search)
      .then((data) => {
        this.setState({
          rows: data.photographers || [],
          totals: data.totals || { jobs: 0, revenue: 0, paid: 0, photographers: 0 },
          loading: false,
          loaded: true
        });
      })
      .catch(() => {
        this.setState({ loading: false, loaded: true });
        if (this.props.showToast) this.props.showToast("Error loading photographer stats.");
      });
  }

  clearFilters() {
    const ytd = PhotographerStats.ytdRange();
    this.setState({ startDate: ytd.startDate, endDate: ytd.endDate, search: "" }, this.loadStats);
  }

  money(value) {
    return `$${Number(value || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  render() {
    const { rows, totals, loading, loaded, startDate, endDate, search } = this.state;

    return (
      <div className="settingsPreferencesGroupingDiv">
        <div className="settingsPreferences">
          <div className="settingsComponentHeading">Photographer Stats</div>

          <div className="settingsGroup">
            <div style={styles.filters}>
              <div className="settingsCompanyInput">
                <label className="formLabel">Start Date</label>
                <input className="formInput" type="date" value={startDate} onChange={this.handleInput("startDate")} />
              </div>
              <div className="settingsCompanyInput">
                <label className="formLabel">End Date</label>
                <input className="formInput" type="date" value={endDate} onChange={this.handleInput("endDate")} />
              </div>
              <div className="settingsCompanyInput">
                <label className="formLabel">Photographer Name</label>
                <input
                  className="formInput"
                  type="text"
                  placeholder="Search by name"
                  value={search}
                  onChange={this.handleInput("search")}
                  onKeyDown={(e) => { if (e.key === "Enter") this.loadStats(); }}
                />
              </div>
              </div>

            <div style={styles.buttons}>
              <button className="settingsButton companyButton" style={styles.btn} onClick={this.loadStats}>Apply</button>
              <button className="settingsButton companyButton" style={styles.btn} onClick={this.clearFilters}>Clear</button>
            </div>

            {loading && <div style={styles.message}>Loading...</div>}

            {!loading && loaded && rows.length === 0 && (
              <div style={styles.message}>No photographers found for this range.</div>
            )}

            {!loading && rows.length > 0 && (
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Photographer</th>
                    <th style={styles.thRight}>Jobs</th>
                    <th style={styles.thRight}>Revenue</th>
                    <th style={styles.thRight}>Paid</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.id}>
                      <td style={styles.td}>{r.name}</td>
                      <td style={styles.tdRight}>{r.jobs}</td>
                      <td style={styles.tdRight}>{this.money(r.revenue)}</td>
                      <td style={styles.tdRight}>{this.money(r.paid)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={styles.foot}>
                    <td style={styles.td}>Totals ({totals.photographers})</td>
                    <td style={styles.tdRight}>{totals.jobs}</td>
                    <td style={styles.tdRight}>{this.money(totals.revenue)}</td>
                    <td style={styles.tdRight}>{this.money(totals.paid)}</td>
                  </tr>
                </tfoot>
              </table>
            )}
          </div>
        </div>
      </div>
    );
  }
}